// Wspólne klocki wyglądu (patch-31): ikony (maski CSS z SVG), maskotka, ramka ze zdjęciem. Bez frameworka, tylko h().
import type { AnchorTile, ImageRef, TeacherLang } from '../types.ts';
import type { AppCtx } from './ctx.ts';
import { h } from './dom.ts';
import { txAttr } from './i18n.ts';
import type { Pair } from './i18n.ts';
import { L } from './taskText.ts';

/** Co klocki wyglądu potrzebują z aplikacji, żeby napisy dla czytników ekranu szły za przełącznikiem EN/PL (brak = polski, jak w testach widoków na atrapach). */
type TextCtx = Pick<AppCtx, 'teacher' | 'account'>;

// --- ikony ----------------------------------------------------------------------------------------
// Ścieżki 24×24 (Material Icons, licencja Apache 2.0; żółw „wolno” — własny rysunek). Rysujemy je maską CSS, więc przyjmują kolor tekstu (currentColor).
const PATHS = {
  close: 'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  back: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z',
  arrow: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z',
  speaker: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z',
  translate: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z',
  calendar: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z',
  replay: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z',
  refresh: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
  down: 'M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z',
  right: 'M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
  edit: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
  check: 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  list: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
  book: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z',
  starFill: 'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
  star: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z',
  plus: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
  lock: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z',
  backspace: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z',
  logout: 'M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z',
  turtle: 'M4 16.2C4 10.8 7.6 7.2 12 7.2s8 3.6 8 9zM19.4 13.4a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0-4.4 0zM6 16h3.2v2.4c0 .9-.7 1.6-1.6 1.6S6 19.3 6 18.4zM14.8 16H18v2.4c0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6zM4.2 15.4 1.4 16.9l2.8.5zM22.2 12.35a.55.55 0 1 1 0 1.1.55.55 0 1 1 0-1.1z', // żółw „wolno” (rysunek własny)
  // żarówka z promykami (kontur, własny rysunek): wartość zaczynająca się od „<” to gotowa treść SVG (rysowana kreską), nie ścieżka wypełnienia
  bulb: `<g fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M8.7 14.3A5.8 5.8 0 1 1 15.3 14.3c-.8.6-1.2 1.4-1.2 2.3v.9H9.9v-.9c0-.9-.4-1.7-1.2-2.3z'/><path d='M10 19.6h4M10.8 21.6h2.4'/><path d='M12 1.2v1.6M4.4 4.4l1.1 1.1M19.6 4.4l-1.1 1.1M1.6 10.6h1.6M20.8 10.6h1.6M4.2 16.8l1.1-1.1M19.8 16.8l-1.1-1.1'/></g>`,
  fire: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z',
} as const;

export type IconName = keyof typeof PATHS;

const uri = (name: IconName): string => {
  const def: string = PATHS[name];
  return `url("data:image/svg+xml,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${def.startsWith('<') ? def : `<path d='${def}'/>`}</svg>`)}")`;
};

/** Ikona rysowana maską: kolor bierze z `color` rodzica, rozmiar z `font-size` (1.25em). */
export function icon(name: IconName, cls = ''): HTMLElement {
  return h('span', { class: `ic ic-${name}${cls ? ` ${cls}` : ''}`, 'aria-hidden': 'true', style: `--m:${uri(name)}` });
}

/** Gwiazdki oceny: `n` pełnych (złote) i reszta obrysów do `total`. Ma tekst alternatywny (w języku z `ctx`, przepisywany po zmianie EN/PL), bo ikony są dekoracją. */
export function starsEl(n: number, total = 3, cls = 'stars', testid?: string, ctx?: TextCtx): HTMLElement {
  const full = Math.max(0, Math.min(total, Math.round(n)));
  const items: HTMLElement[] = [];
  for (let i = 0; i < total; i++) items.push(h('span', { class: `star ${i < full ? 'full' : 'empty'}` }, icon(i < full ? 'starFill' : 'star')));
  const label = (lang: TeacherLang): string => (lang === 'en' ? `${full} of ${total} stars` : `${full} z ${total} gwiazdek`);
  const el = h('div', { class: cls, role: 'img', 'data-stars': full, 'data-testid': testid }, ...items);
  if (ctx) txAttr(ctx, el, 'aria-label', label);
  else el.setAttribute('aria-label', label('pl'));
  return el;
}

// --- maskotka ---------------------------------------------------------------------------------------
// Postać użytkownika (wycięta z makiet): public/mascot/<poza>.webp. Pozy z makiet: powitanie, ekran główny, wynik próby, banter i logowanie.

export const POSES = [
  'login', 'idle', 'calm',
  'w-ready', 'w-hello', 'w-party',
  'h-coffee', 'h-surprised', 'h-confetti', 'h-peek', 'h-cheer', 'done-heart',
  'celebrate',
  'r-trophy', 'r-cheer', 'r-coffee', 'r-lounge', 'r-think', 'r-shrug', 'r-sleep',
  // pozy kroków lekcji (patch-49): pogadanka przed krokiem, ekran gramatyki i pole obrazka w krokach bez rysunku
  'step-repeat', 'step-read', 'step-grammar', 'step-words', 'step-type', 'step-final',
] as const;
export type Pose = (typeof POSES)[number];

/**
 * Wersja plików ludzika — dopisana do adresu (`?v=`), żeby po zmianie obrazków przeglądarka i service worker pobrały nowe, a nie pokazały starej kopii.
 * Podbij przy każdej podmianie plików w public/mascot (patch-33b: ostrzejsze pozy i nowa „calm”; patch-41: pozy reakcji r-* z wyostrzonym konturem; patch-42: nowa „idle” z makiety 8a; patch-43: siedem póz reakcji r-* z makiet 1a–7a; patch-49: sześć póz kroków step-*).
 */
export const MASCOT_REV = '44';
export const poseSrc = (pose: Pose): string => `./mascot/${pose}.webp?v=${MASCOT_REV}`;

/**
 * Pliki póz są większe niż rozmiar, w jakim ułożono ekrany (ostrzejsze na tabletach i ekranach Retina). `srcset` z gęstością każe przeglądarce liczyć
 * rozmiar naturalny obrazka jako szerokość pliku / gęstość, więc układ jest taki sam jak przy dawnych, mniejszych plikach.
 */
export const POSE_DENSITY: Readonly<Record<Pose, number>> = {
  'login': 1.25, 'idle': 2.632, 'calm': 1.607,
  'w-ready': 1.25, 'w-hello': 1.299, 'w-party': 1.25,
  'h-coffee': 2.392, 'h-surprised': 2.305, 'h-confetti': 2.381, 'h-peek': 2.426, 'h-cheer': 2.416, 'done-heart': 1.718,
  'celebrate': 1.25,
  'r-trophy': 2.976, 'r-cheer': 3, 'r-coffee': 3, 'r-lounge': 2.674, 'r-think': 3, 'r-shrug': 3, 'r-sleep': 2.924,
  // naturalna wysokość ≈ 560 px (jak „calm”): plik 1000 px wysokości → 1,786
  'step-repeat': 1.657, 'step-read': 1.666, 'step-grammar': 1.786, 'step-words': 1.786, 'step-type': 1.786, 'step-final': 1.414,
};

/**
 * Poza maskotki dla kroku lekcji (patch-49): zamknięte oczy (słucha) — „Listen and repeat”, książka — „Speak out loud”, myśli z „?” — gramatyka, złożone dłonie — pytania do słów
 * („Words QA”), zeszyt — „Missing words”, pompony — „Co powiesz? / Build sentences”. Kluczem jest `step` pogadanki (`BanterLine.step`) albo faza zadania „powiedz” (`SpeakTask.phase`);
 * scenka i rozgrzewka nie mają własnej pozy (zostaje dotychczasowa).
 */
export const STEP_POSES = {
  repeat: 'step-repeat',
  read: 'step-read',
  grammar: 'step-grammar',
  words: 'step-words',
  type: 'step-type',
  build: 'step-final',
  final: 'step-final',
} as const satisfies Record<string, Pose>;
export type StepKey = keyof typeof STEP_POSES;
/** Poza kroku albo `null`, gdy krok jej nie ma (scenka, rozgrzewka, brak kroku). */
export const stepPose = (step: string | undefined): Pose | null => (step !== undefined && Object.hasOwn(STEP_POSES, step) ? STEP_POSES[step as StepKey] : null);

let stepPosesWarm = false;
/**
 * Pobiera pozy kroków przy starcie lekcji (raz na uruchomienie aplikacji): service worker zapamiętuje pliki dopiero przy pierwszym pobraniu, więc bez tego pierwsza pogadanka kroku
 * pokazałaby puste pole, dopóki plik (do ~175 KB) nie dojdzie, a bez internetu — nie pokazałaby się wcale. Poza przeglądarką (testy) nic nie robi.
 */
export function warmStepPoses(): void {
  if (stepPosesWarm || typeof Image === 'undefined') return;
  stepPosesWarm = true;
  for (const pose of new Set(Object.values(STEP_POSES))) new Image().src = poseSrc(pose);
}

/** Maskotka w danej pozie. Obrazek jest dekoracją (alt pusty); `cls` dodaje klasy układu. */
export function mascot(pose: Pose, cls = ''): HTMLElement {
  const src = poseSrc(pose);
  return h('img', { class: `mascot pose-${pose}${cls ? ` ${cls}` : ''}`, src, srcset: `${src} ${POSE_DENSITY[pose]}x`, alt: '', 'aria-hidden': 'true', draggable: 'false', decoding: 'async', 'data-pose': pose, 'data-testid': 'mascot' });
}

/**
 * Skala czcionek ekranu z długim tekstem (SPEC §23.24.8, patch-43): zdania do `FIT_FREE` znaków mają rozmiar wzorca; dłuższe zdania (część A1, A2–B2
 * (do 97 znaków) zmniejszają zdanie, kwestię rozmówcy, polecenie i klocki, żeby ekran mieścił się w oknie bez przewijania. CSS mnoży rozmiary przez `var(--fit, 1)`.
 */
export const FIT_FREE = 60;
export const FIT_MIN = 0.62;
export function fitOf(len: number, free: number = FIT_FREE, exp: number = 1.3): number {
  if (len <= free) return 1;
  const f = Math.max(FIT_MIN, Math.round(Math.pow(free / len, exp) * 100) / 100);
  return f >= 0.97 ? 1 : f; // różnica poniżej 3% jest niezauważalna — zostają rozmiary wzorca
}
/**
 * Skala scenki (patch-43): kwestia rozmówcy (dwie linijki) i zdanie dziecka (do trzech) dzielą wysokość okna, a zarezerwowane miejsca na tłumaczenie i wynik
 * zostają — na iPadzie w poziomie (1024×768, 1180×820) scenka z 67–72 znakami (zdanie + kwestia) wychodziła poza okno o 22–35 px. Od `SCENE_KNEE` znaków
 * scenka ma więc co najwyżej `SCENE_KNEE_FIT` (przy 0,95 brakowało jeszcze 5 px na 1024×768), a dłuższe schodzą dalej według zwykłej krzywej (75 znaków, wykładnik 0,8).
 */
export const SCENE_KNEE = 58;
export const SCENE_KNEE_FIT = 0.9;
export function sceneFitOf(len: number): number {
  const f = fitOf(len, 75, 0.8);
  return len > SCENE_KNEE ? Math.min(f, SCENE_KNEE_FIT) : f;
}
export function sceneFitProps(len: number): { style?: string } {
  const f = sceneFitOf(len);
  return f < 1 ? { style: `--fit: ${f}` } : {};
}

/**
 * Skala karty „Co powiesz?” (patch-43): oprócz najdłuższej karty liczy się opis sytuacji nad nimi. Opis dłuższy niż `SAY_SITUATION_KNEE` znaków zajmuje trzy wiersze, a trzy karty
 * po dwa wiersze nie mieszczą się już w oknie 1024×768 (a1-005, opis 73 znaki, najdłuższa karta 31 — nadmiar 103 px przy skali 1,0, 17 px przy 0,9, 0 przy 0,85).
 * Dlatego opis dłuższy niż próg daje co najwyżej `SAY_SITUATION_FIT`, a dłuższy niż 75 znaków — dalej według zwykłej krzywej (wykładnik 0,8).
 */
export const SAY_SITUATION_KNEE = 66;
export const SAY_SITUATION_FIT = 0.85;
export function sayFitOf(cardLen: number, situationLen: number): number {
  const bySituation = situationLen > SAY_SITUATION_KNEE ? Math.min(SAY_SITUATION_FIT, fitOf(situationLen, 75, 0.8)) : 1;
  return Math.min(fitOf(cardLen, 30, 0.6), bySituation);
}
export function sayFitProps(cardLen: number, situationLen: number): { style?: string } {
  const f = sayFitOf(cardLen, situationLen);
  return f < 1 ? { style: `--fit: ${f}` } : {};
}

/**
 * Atrybut `style` z zmienną `--fit` dla korzenia ekranu zadania; bez niego (tekst krótki) ekran ma rozmiary wzorca.
 * `len` to „efektywna długość” tekstu ekranu, `free` — do ilu znaków rozmiary zostają wzorcowe (inne dla ekranów o różnej szerokości kolumny tekstu), `exp` — jak szybko maleje skala.
 */
export function fitProps(len: number, free: number = FIT_FREE, exp: number = 1.3): { style?: string } {
  const f = fitOf(len, free, exp);
  return f < 1 ? { style: `--fit: ${f}` } : {};
}

/**
 * Siatka bezpieczeństwa dla skali `--fit` (patch-45, rozszerzona w patch-53): długość tekstu nie mówi, ile rzędów zajmą klocki albo karty. Krótkie zdanie B2 (41 znaków) dostaje pełną skalę, a jego
 * cztery klocki łamią się na trzy rzędy i strona jest o 39 px za wysoka na iPadzie 1024×768 — i odwrotnie, dłuższe zdanie z mniejszą skalą mieści się. Dlatego po wstawieniu ekranu do
 * dokumentu — tylko w układzie, w którym karta jest dokowana nad paskiem (tablet i większe, tak jak w CSS: ≥ 761 × ≥ 640 px) — mierzymy stronę i zmniejszamy `--fit` co 0,04, aż strona mieści się
 * w oknie (najmniej `FIT_MIN`). Na telefonie strona ma się przewijać, więc tam nic nie robimy. Bez okna, `matchMedia` albo `requestAnimationFrame` (testy jednostkowe) — nic.
 *
 * Patch-53: (1) ekrany z rozmową i karta gramatyki (`grow`) także się POWIĘKSZAJĄ — do największej skali (najwyżej `FIT_GROW_MAX`), przy której strona jeszcze mieści się w oknie; makiety mają
 * treść wypełniającą cały ekran (na tablecie w pionie czcionki ok. 1,4× większe niż „skala 1”), a puste pasy nad i pod treścią były najczęstszą różnicą względem makiet. (2) Dopasowanie
 * powtarza się po wczytaniu czcionek (szerokość tekstu w prawdziwej Nunito różni się o kilka procent od czcionki zapasowej i bywa inna w innej wersji przeglądarki) i po zmianie rozmiaru okna
 * (obrót iPada): skala może spaść, a na ekranach `grow` wrócić; na pozostałych — wrócić najwyżej do skali początkowej.
 */
export const FIT_STEP = 0.04;
export const FIT_GROW_MAX = 1.5;
export const FIT_DOCKED_QUERY = '(min-width: 761px) and (min-height: 640px)';
const round2 = (x: number): number => Math.round(x * 100) / 100;
/**
 * Szuka skali dla ekranu: od `start` w dół (co `FIT_STEP`, najmniej `FIT_MIN`), aż `fits()` mówi „mieści się”; potem — dopóki mieści się — w górę, najwyżej do `max`.
 * `apply(f)` ustawia skalę (i przelicza układ), `fits()` mierzy stronę przy ustawionej skali. Zwraca ustawioną skalę. Czysta funkcja (testy jednostkowe bez przeglądarki).
 */
export function searchFit(start: number, max: number, fits: () => boolean, apply: (f: number) => void): number {
  let f = Math.min(Math.max(start, FIT_MIN), Math.max(max, FIT_MIN));
  if (f !== start) apply(f);
  for (let i = 0; i < 40 && f > FIT_MIN && !fits(); i++) {
    f = Math.max(FIT_MIN, round2(f - FIT_STEP));
    apply(f);
  }
  if (!fits()) return f;
  for (let i = 0; i < 40; i++) {
    const next = round2(f + FIT_STEP);
    if (next > max + 1e-9) break;
    apply(next);
    if (!fits()) {
      apply(f);
      break;
    }
    f = next;
  }
  return f;
}
/** Uchwyt dopasowania ekranu do okna: `refit` — dopasuj od nowa (układ ekranu zmienił się sam); `dispose` — zdejmij nasłuchy (przy `destroy` ekranu). */
export interface FitHandle {
  refit: () => void;
  dispose: () => void;
}
const NO_FIT: FitHandle = { refit: () => {}, dispose: () => {} };
export function fitToWindow(el: HTMLElement, opts: { grow?: boolean } = {}): FitHandle {
  const w = (globalThis as { window?: Window }).window;
  if (!w || typeof w.requestAnimationFrame !== 'function' || typeof w.matchMedia !== 'function') return NO_FIT;
  const startStyle = el.style.getPropertyValue('--fit'); // skala początkowa z `fitProps` (albo pusta = 1): do niej wracamy, gdy okno przestaje być dokowane
  const initial = Number(startStyle) || 1;
  const max = opts.grow ? FIT_GROW_MAX : initial;
  const doc = el.ownerDocument;
  let disposed = false;
  let widthSeen = w.innerWidth;
  const run = (): void => {
    if (disposed || !el.isConnected) return;
    if (!w.matchMedia(FIT_DOCKED_QUERY).matches) { // telefon albo okno za niskie: układ nie jest dokowany, strona się przewija — wracamy do skali początkowej (po obrocie z tabletu)
      if (el.style.getPropertyValue('--fit') !== startStyle) {
        if (startStyle) el.style.setProperty('--fit', startStyle);
        else el.style.removeProperty('--fit');
      }
      return;
    }
    const page = doc.documentElement;
    searchFit(Number(el.style.getPropertyValue('--fit')) || 1, max, () => page.scrollHeight <= w.innerHeight + 1, (f) => el.style.setProperty('--fit', String(f)));
  };
  const fonts = doc.fonts as FontFaceSet | undefined;
  let queued = false;
  const dispose = (): void => {
    disposed = true;
    w.removeEventListener('resize', onResize);
    fonts?.removeEventListener?.('loadingdone', later);
  };
  const later = (): void => {
    if (disposed) return;
    if (!el.isConnected) { // ekran już zniknął (bez `destroy`): zdejmujemy nasłuchy, żeby nie trzymać oderwanego drzewa DOM
      dispose();
      return;
    }
    if (queued) return;
    queued = true;
    w.requestAnimationFrame(() => {
      queued = false;
      run();
    });
  };
  const onResize = (): void => {
    // klawiatura ekranowa zmniejsza TYLKO wysokość okna na czas pisania — wtedy tekst nie ma skakać; zmiana szerokości (obrót, zmiana rozmiaru okna) przelicza zawsze
    const heightOnly = w.innerWidth === widthSeen;
    widthSeen = w.innerWidth;
    if (heightOnly && el.isConnected && doc.activeElement?.tagName === 'INPUT') return;
    later();
  };
  w.requestAnimationFrame(run);
  w.addEventListener('resize', onResize);
  if (fonts) {
    void fonts.ready.then(later);
    fonts.addEventListener?.('loadingdone', later);
  }
  // ekran, którego układ zmienia się sam (np. „Co powiesz?” odsłania karty), prosi o ponowne dopasowanie; przy aktywnym polu tekstowym (klawiatura ekranowa skraca okno) nic nie robi
  return { refit: () => { if (doc.activeElement?.tagName !== 'INPUT') later(); }, dispose };
}

/** Adres obrazka lekcji kursu v2 (plik powstaje przez `npm run images:generate`, trafia tu przez `npm run images:publish`). */
export const lessonImageSrc = (id: string): string => `./img/lessons/${id}.png`;

/**
 * Obrazek lekcji kursu v2 (historia kroków 1–2; w pytaniu kroku 4 — obrazek słowa) — sam rysunek, bez ramki. Dopóki obrazka nie wygenerowano (albo plik się nie wczytał), w tym samym polu
 * widać emoji celów lekcji — lekcja działa bez obrazków. `badge`: emoji słowa w rogu (karta słówka).
 */
export function lessonPicture(ref: ImageRef, badge?: string): HTMLElement {
  // Zapasowe emoji nie może być wyższe niż pole rysunku (patch-43): jeden rząd, najwyżej trzy emoji, a rozmiar liczy CSS z wymiarów pola (`.fallback`, `--n`).
  // Pięć dużych emoji w kolumnie rozpychało pole do 315 px i na iPadzie scenka wychodziła poza okno (a1-003, a1-902).
  const shown = ref.emoji.slice(0, FALLBACK_EMOJI_MAX);
  const fallback = (): HTMLElement => {
    photo.classList.add('fallback');
    return h('span', { class: 'photo-emoji lesson-emoji', 'aria-hidden': 'true', 'data-testid': 'photo-emoji' }, shown.length > 0 ? shown.join(' ') : '🖼️');
  };
  const img = h('img', { class: 'photo-img lesson-img', src: lessonImageSrc(ref.id), alt: '', draggable: 'false', decoding: 'async', 'data-testid': 'photo-img' });
  img.addEventListener('error', () => paper.replaceChildren(fallback()));
  const paper = h('div', { class: 'paper' }, img);
  const photo = h('div', { class: 'photo lesson', style: `--n: ${Math.max(1, shown.length)}`, 'data-testid': 'photo', 'data-lesson-image': ref.id, 'data-has-img': '1' },
    paper,
    badge ? h('span', { class: 'photo-badge', 'aria-hidden': 'true', 'data-testid': 'photo-badge' }, badge) : null,
  );
  return photo;
}

/** Ile emoji celów pokazuje zapasowe pole obrazka lekcji (kiedy pliku obrazka jeszcze nie ma). */
export const FALLBACK_EMOJI_MAX = 3;

/**
 * Pole obrazka na ekranie bez obrazka lekcji (rozmowa, luki, układanie zdania, „Co powiesz?” — SPEC §23.26): spokojna maskotka w tym samym polu 3:2, w którym stoi rysunek,
 * więc układ ekranu jest ten sam, co z obrazkiem (test układu w tests/e2e/layout-stable.mjs). Obrazek maskotki jest dekoracją.
 */
export function mascotPicture(pose: Pose = 'calm'): HTMLElement {
  return h('div', { class: 'photo lesson stage', 'data-testid': 'photo', 'data-stage': '1', 'data-has-img': '0' }, h('div', { class: 'paper' }, mascot(pose)));
}

/**
 * Kafelek zamiast obrazka słowa (SPEC §23.24): słowa, którego nie da się narysować („hello”, „please”, „not”, „chociaż”), nie zostawiamy w pustym polu —
 * duże emoji celu i jedno zdanie po polsku, w którym sytuacji to słowo pada. Zajmuje to samo pole co rysunek, więc układ ekranu się nie zmienia.
 */
export function anchorTile(tile: AnchorTile, badge?: string): HTMLElement {
  return h('div', { class: 'photo lesson tile', 'data-testid': 'photo', 'data-tile': '1', 'data-has-img': '0' },
    h('div', { class: 'paper' },
      h('span', { class: 'tile-emoji', 'aria-hidden': 'true', 'data-testid': 'tile-emoji' }, tile.emoji),
      tile.situationPl ? h('p', { class: 'tile-line', 'data-testid': 'tile-line' }, tile.situationPl) : null,
    ),
    badge ? h('span', { class: 'photo-badge', 'aria-hidden': 'true', 'data-testid': 'photo-badge' }, badge) : null,
  );
}

/** Kotwica słowa przy pytaniu kroku 4: obrazek słowa albo kafelek (SPEC §23.26); bez żadnego z nich — maskotka z pozą kroku „słówka”. */
export function anchorPicture(task: { image?: ImageRef; tile?: AnchorTile }): HTMLElement {
  if (task.tile) return anchorTile(task.tile);
  return task.image ? lessonPicture(task.image) : mascotPicture('step-words');
}

/**
 * Ikona 文A (obok chipa w zadaniu): przełącza polskie tłumaczenie. `on` = tłumaczenie widać; `aria-pressed` i klasa `on` odzwierciedlają stan.
 * Podpis (aria-label i title) jest w języku z `ctx` i przepisuje się po zmianie EN/PL bez ruszania stanu przycisku.
 */
export function translateButton(on: boolean, onChange: (on: boolean) => void, ctx?: TextCtx): HTMLButtonElement {
  let state = on;
  const btn = h('button', { type: 'button', class: `icon-sq${on ? ' on' : ''}`, 'data-testid': 'show-pl', 'aria-pressed': String(on), onclick: () => {
    state = !state;
    btn.classList.toggle('on', state);
    btn.setAttribute('aria-pressed', String(state));
    onChange(state);
  } }, icon('translate'));
  labelFor(ctx, btn, L.polishTranslation);
  return btn;
}

/** aria-label i title przycisku z ikoną: w języku z `ctx` (bez niego po polsku). */
export function labelFor<T extends Element>(ctx: TextCtx | undefined, el: T, pair: Pair): T {
  for (const attr of ['aria-label', 'title']) {
    if (ctx) txAttr(ctx, el, attr, pair);
    else el.setAttribute(attr, pair.pl);
  }
  return el;
}
